import * as yup from "yup";

export const EMAIL_REGEX = /[\w.+-]{1,64}@[\w-]{1,253}\.[\w.-]{2,63}/;

const emailSchema = yup.string().email();

export const isValidEmail = (value: string) => emailSchema.isValidSync(value);
